import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const payment = {
	state: {
		project: ''
	},
	getters: {
		getProject: state => state.project
	},
	actions: {
		makePayment: ({ commit, dispatch }, data) => {
			return new Promise((resolve, reject) => {
				axios.post('api/payment', data).then(response => {
					resolve(response.data.data.intent.client_secret);
				});
			});
		},
		makePaymentManual: ({ commit, dispatch }, data) => {
			return new Promise((resolve, reject) => {
				axios.post('api/payment_manual', data).then(response => {
					resolve(response.data.status);
				});
			});
		},
		setProjectToPay: ({ commit }, project) => {
			commit('setproject', project)
		},
		eraseProject: ({ commit }) => {
			commit('setproject', null)
		},
		createSubscription: ({ commit, dispatch }, data) => {
			return new Promise((resolve, reject) => {
				axios.post('api/subscription/create', data).then(response => {
					if (response.data.status) {
						resolve(true);
					} else {
						resolve(false);
						commit('setError', response.data.error);
					}
				}).catch(error => {
					resolve(false);
					commit("setError", error.response.data.error);
				});
			});
		},
		editSubscription: ({ commit, dispatch }, data) => {
			return new Promise((resolve, reject) => {
				axios.post('api/subscription/edit', data).then(response => {
					resolve(response.data.status);
				});
			});
		},
		getSubscriptions: ({ commit, dispatch }) => {
			return new Promise((resolve, reject) => {
				axios.get('api/subscription/list').then(response => {
					resolve(response.data.subscriptions);
				});
			});
		},
		deleteSubscriptions: ({ commit, dispatch }) => {
			return new Promise((resolve, reject) => {
				axios.post('api/subscription/delete').then(response => {
					resolve(response.data);
				});
			});
		},
	},
	mutations: {
		setproject: (state, project) => {
			state.project = project;
		}
	}
}

export default payment;



// WEBPACK FOOTER //
// ./src/store/payment.js